import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { refundDetails, newStudentDetails, sampleReceiptDetail, negativeReceiptDetails } from './constants';
import PaymentDetails from './PaymentDetails';
import NewReceipts from './NewReceipts';
import { displayFile } from '../refundApproval/view/constant';
const RefundDetails = ({
    receiptDetails = {}
}) => {

    const getFormatCol = (label = '', value = '', key = '', flag = false, index) => {
        let displayValue = 'N/A';

        if (value && value !== ' ') {
            if (receiptDetails?.orderType === 'INTERNAL_REFUND' && key === 'subOrderType') {
                displayValue = value.split('_')[0];
            }
            else if (Array.isArray(value)) {
                if (label.toLowerCase().includes('attachment') || label.toLowerCase().includes('supporting doc')) {
                    displayValue = displayFile(value);
                } else if (value.length > 0) {
                    displayValue = value.join(', ');
                } else {
                    displayValue = '-';
                }
            } else {
                if(key === 'supportingDocKey') {
                    displayValue = displayFile([value]);
                } else {
                    displayValue = value;
                }
            }
        }

        return (
            <>
                <Col md={6} className="mt-24">
                    <div>
                        <div className="regular-small mb-10">
                            {label}
                        </div>
                        <div className="large-semi-bold label-color">
                            {displayValue}
                        </div>
                    </div>
                </Col>

                {flag && index === 4 && (
                    <Col md={6} className="mt-24"></Col>
                )}
            </>
        );
    };

    const receiptKeys = receiptDetails?.orderType === 'INTERNAL_REFUND' ? negativeReceiptDetails : refundDetails;

    return (
        <>
            <Card >
                <CardBody>
                    <diV className='dark-text label-color'>Refund details</diV>
                    <Row>
                        {receiptKeys.map((item, index) => {
                            return getFormatCol(item?.label, receiptDetails[item?.key], item?.key, false, index)
                        })}
                    </Row >

                    {receiptDetails?.correctApplicationId && <><div className='tiny-semi-bold mt-5' >
                        NEW STUDENT DETAILS
                    </div>
                        <Row>
                            {newStudentDetails.map((item, index) => {
                                return getFormatCol(item?.label, receiptDetails[item?.key], true, index)

                            })}
                        </Row ></>
                    }
                    <div className='mt-24'>
                        <PaymentDetails refundType={receiptDetails?.orderType} oldReceiptList={receiptDetails?.orderType !== 'INTERNAL_REFUND' ? receiptDetails?.oldReceiptList : receiptDetails?.negativeReceipts} />
                    </div>
                </CardBody>
            </Card>

            <Card>
                <CardBody>
                    <div className=''>
                        <NewReceipts refundType={receiptDetails?.orderType} newReceiptList={receiptDetails?.orderType !== 'INTERNAL_REFUND' ? receiptDetails?.paymentModeDetails : receiptDetails?.positiveReceipts} />
                    </div>
                </CardBody>
            </Card>
        </>
    )
}

export default RefundDetails;